// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delivery-instruction[data-v-5cfffb1c]{background:rgba(155,11,84,.15);border-radius:6px;color:#000;padding:1rem 1.5rem;word-break:break-word}.delivery-instruction ul[data-v-5cfffb1c]{margin-top:.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
